import { useTranslation } from 'react-i18next';
import { locationContent } from '../../data/location';

export default function SiteFooter() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  const handleAnchor = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 72;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <footer className="site-footer">
      <div className="container">
        <div className="site-footer__grid">
          <div className="site-footer__brand">
            <h3>Villa Spilia</h3>
            <p>
              <em>{t('footer.tagline')}</em>
            </p>
          </div>

          <div>
            <h4>{t('footer.explore')}</h4>
            <ul>
              <li><a href="#story" onClick={(e) => handleAnchor(e, 'story')}>{t('nav.story')}</a></li>
              <li><a href="#apartments" onClick={(e) => handleAnchor(e, 'apartments')}>{t('nav.apartments')}</a></li>
              <li><a href="#gallery" onClick={(e) => handleAnchor(e, 'gallery')}>{t('nav.gallery')}</a></li>
              <li><a href="#location" onClick={(e) => handleAnchor(e, 'location')}>{t('nav.location')}</a></li>
            </ul>
          </div>

          <div>
            <h4>{t('footer.contact')}</h4>
            <ul>
              <li>{t('location.addressValue')}</li>
              <li>
                <a href={`tel:${locationContent.phone.replace(/\s+/g, '')}`}>{locationContent.phone}</a>
              </li>
              <li>
                <a href={`mailto:${locationContent.email}`}>{locationContent.email}</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="site-footer__bottom">
          <span>{t('footer.copyright', { year })}</span>
        </div>
      </div>
    </footer>
  );
}
